import { useEffect, useState } from "react";
import { CMCardChartSocialImpact } from "./card-chart-social-impact.styles";
import ChartSocialImpact from "./chart_social-impact.component";

const CardChartSocialImpact = ({icon, title, quantity, quantity_past_month, difference, chart_title, chart_data}) => {

    const [formattedQuantity, setFormattedQuantity] = useState("")
    const [formattedDifference, setFormattedDifference] = useState("")
    const [styleDifference, setStyleDifference] = useState("difference_text text_gray")

    const chartColors = {
        instagram: {
            stroke_line: "#6e0075",
            stroke: "#C400C5",
            fill: "#ea9cff"
        },
        youtube: {
            stroke_line: "#750000",
            stroke: "#e54c49",
            fill: "#ecaca4"
        },
        spotify: {
            stroke_line: "#127500",
            stroke: "#5fc283",
            fill: "#bce9ce"
        },
        tiktok: {
            stroke_line: "#00756d",
            stroke: "#75d3d3",
            fill: "#adf3f3"
        }
    }

    useEffect(() => {
        try {
            const value = parseFloat(quantity)
            setFormattedQuantity(formatValue(value))
        } catch (e){
            setFormattedQuantity("0")
            console.log(e)
        }
    }, [quantity])

    useEffect(() => {
        try {
            const value_difference = parseFloat(difference)
            const formattedStyle = 'difference_text ' + (value_difference > 0 ? 'text_green' : value_difference < 0 ? 'text_red' : 'text_gray')
            setStyleDifference(formattedStyle)

            const value_quantity_past_month = parseFloat(quantity_past_month)
            const percentage = (100 / value_quantity_past_month) * Math.abs(value_difference)
            const sign = value_difference > 0 ? '+' : value_difference < 0 ? '-' : ''
            const formattedDifference = `${sign}${formatValue(difference.replace('-',''))} (${percentage.toFixed(2)}%)`
            setFormattedDifference(formattedDifference)
        }
        catch (e){
            console.log(e)
        }
    }, [difference, quantity_past_month])

    const formatValue = (value) => {
        let formattedValue =
            value >= 1000000 ? (value/1000000).toFixed(2).replace(/\.0$/, '') + 'M' :
            value >= 1000 ? (value/1000).toFixed(2).replace(/\.0$/, '') + 'K' :
            value
        return formattedValue
    }

    return (
        <CMCardChartSocialImpact>
            <div className="top-container">
                <div className="title_container">
                    <img clasName="title_icon" width="20" src={require(`./../../Assets/CHART_ICONS/${icon}.svg`)} />
                    <label className="title_text">{title}</label>
                </div>
                <label className="quantity">{formattedQuantity}</label>
                <div className="diffrence_container">
                    <label className={styleDifference}>{formattedDifference}</label>
                </div>
                <label className="chart_title">{chart_title}</label>
            </div>
            <div className="chart_container">
                <ChartSocialImpact style={chartColors[icon]} values={chart_data}></ChartSocialImpact>
            </div>
        </CMCardChartSocialImpact>
    )
}

export default CardChartSocialImpact;